export const OVERLAY_STATUS = 'overlay_status'; 
export const CURRENT_USER = 'current_user'; 
export const WIDGET_TYPES = 'widget_types';